import React from "react";
import "./Navbar.css";
import cv from "../images/resume.pdf";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logo.png";
import lanre from "../images/Lanre.png";

const Navbar = () => {
  const location = useLocation();
  const { pathname: exactLocation } = location;
  const checkLocation = exactLocation.split("/");
  console.log(checkLocation);

  // Open the sidenav
  function openNav() {
    document.getElementById("mySidenav").style.width = "100%";
  }

  // Close/hide the sidenav
  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg d-none d-lg-block">
        <div className="imagediv container-lg">
          <p className="brand">
            Lanre <span style={{ color: "#ad4328" }}>Adeolu.</span>
          </p>
          <button
            className="navbar-toggler"
            type="button"
            id="mobile-nav-btn"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className={
                    checkLocation[1] === "" ? "active nav-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    checkLocation[1] === "portfolio"
                      ? "active nav-link"
                      : "nav-link"
                  }
                  to="/portfolio"
                >
                  Portfolio
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    checkLocation[1] === "resume"
                      ? "active nav-link"
                      : "nav-link"
                  }
                  to="/resume"
                >
                  Resume
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={
                    checkLocation[1] === "contact"
                      ? "active nav-link"
                      : "nav-link"
                  }
                  to="/contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Navbar */}
      <nav className="mobile-nav pt-3 d-block d-lg-none">
        <div id="mySidenav" className="sidenav">
          <a class="navbar-brand mobile-logo closebtn-logo" href="#">
            <p className="brand">
              Lanre <span style={{ color: "#ad4328" }}>Adeolu.</span>
            </p>
          </a>
          <a href="#" class="closebtn" onClick={closeNav}>
            &times;
          </a>
          <div className="sidenav-links">
            <Link
              className={
                checkLocation[1] === "" ? "active nav-link" : "nav-link"
              }
              aria-current="page"
              to="/"
            >
              Home
            </Link>
            <Link
              className={
                checkLocation[1] === "portfolio"
                  ? "active nav-link"
                  : "nav-link"
              }
              to="/portfolio"
            >
              Portfolio
            </Link>
            <Link
              className={
                checkLocation[1] === "resume" ? "active nav-link" : "nav-link"
              }
              to="/resume"
            >
              Resume
            </Link>
            <Link
              className={
                checkLocation[1] === "contact" ? "active nav-link" : "nav-link"
              }
              to="/contact"
            >
              Contact
            </Link>
          </div>
        </div>

        {/* <!-- Use any element to open the sidenav --> */}
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <a class="navbar-brand" href="/">
                <img
                  src={lanre}
                  alt="logo"
                  className="logo-mobile"
                  width="15%"
                />
              </a>
            </div>
            <span onClick={openNav} className="hamburger col-6 text-end">
              <i class="bi bi-list"></i>
            </span>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
